export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag('config', 'G-HMT93E1Q27', {
      page_path: location.pathname,
    })
  }
}
